import { z } from 'zod';

export const pushNotificationEventSchema = z.discriminatedUnion('key', [
  z.object({
    key: z.literal('pending-route'),
    route: z.string(),
    timestamp: z.number(),
  }),
]);

export type PushNotificationEvent = z.infer<typeof pushNotificationEventSchema>;
